import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
Snackbar,
} from 'framework-ui-components';


class FileSelector extends Component {
    static propTypes = {
        accept: PropTypes.arrayOf(PropTypes.string),
        allowUpload: PropTypes.func,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
        ]),
        max: PropTypes.number,
        multiple: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        accept: '',
        allowUpload: null,
        children: null,
        max: 10240,
        multiple: false,
        onChange: null,
    };

    state = {
        acceptedFileTypes: this.props.accept,
    };

    updateFiles = (e) => {
        e.preventDefault();
        const {
            allowUpload, max, multiple, onChange,
        } = this.props;

        const { files } = e.target;
        for (let i = 0; i < files.length; i += 1) {
            const file = files[i];

            if (max && Math.ceil(file.size / 1000000) > max) {
                Snackbar.show({ type: Snackbar.Types.ERROR, message: `Il file supera la dimensione massima accettata: ${max} MB` });
                return;
            }

            let type = `.${file.name.split('.').pop()}`;
            if (type.indexOf('/') > -1) {
                type = type.substr(type.indexOf('/') + 1);
            }

            if (this.extensionAccepted(type)) {
                const formData = new FormData();
                formData.append('file', file);

                if ((allowUpload == null) || (allowUpload != null && allowUpload(file))) {
                    if (!multiple) {
                        onChange && onChange(e, file);
                    }
                }
            }
        }

        if (multiple) {
            onChange && onChange(e);
        }
    };

    extensionAccepted = (extension) => {
        const { acceptedFileTypes } = this.state;
        if ((acceptedFileTypes
            && acceptedFileTypes.map(x => x.toLowerCase())
                .indexOf(extension.toLowerCase()) === -1)) {
            Snackbar.show({ type: Snackbar.Types.ERROR, message: `Tipo di file non supportato: ${extension}` });
            return false;
        }
        return true;
    };

    render() {
        const {
            children,
            accept,
            multiple,
        } = this.props;
        const opts = {};
        if (multiple) {
            opts.multiple = 'multiple';
        }

        return (
            <div className="upload">
                <div
                    className="upload__button"
                    onClick={() => this.refInput.click()}
                >
                    {children}
                </div>
                <input
                    {...opts}
                    accept={(accept && accept.map(x => x).join(',')) || true}
                    className="upload__input"
                    name="fileupload"
                    onChange={this.updateFiles}
                    ref={(r) => { this.refInput = r; }}
                    type="file"
                />
            </div>
        );
    }
}

export default FileSelector;
